import { Colors } from "../config/Constants";

const RegisterImageUpload = ({
  onFileSelect,
  description,
  label,
  file,
  name,
  error,
}) => {
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = e.dataTransfer.files;
    // @ts-ignore
    onFileSelect(droppedFiles);
  };

  const handleFileSelect = (e) => {
    const selectedFiles = e.target.files;
    // @ts-ignore
    onFileSelect(selectedFiles);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <label>
        <div
          style={{
            marginTop: "0.5rem",
            marginBottom: "0.25rem",
            fontSize: "14px",
            color: Colors.cloudyGrey,
          }}
        >
          {label}
        </div>

        <div
          className="file-upload-container"
          style={{
            width: "100%",
            gap: "0.5rem",
            border: "2px dashed #ccc",
            padding: "16px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            placeItems: "center",
            placeContent: "center",
            fontSize: "14px",
            borderRadius: "8px",
            boxSizing:'border-box'
          }}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <img
            style={{ width: "64px" }}
            src={require("../assets/images/amd_upload.png")}
          />
          <div style={{ color: "#475467" }}>
            <span style={{ color: Colors.red }}>Click to upload</span> drag and
            drop
          </div>
          <input
            type="file"
            onChange={handleFileSelect}
            style={{ display: "none" }}
            id="file-input"
            accept="image/jpeg, image/png"
          />
          <div
            htmlFor="file-input"
            style={{ color: "#475467", cursor: "pointer" }}
          >
            {description}
          </div>
        </div>
      </label>
      {error && <div style={{ color: "red", fontSize: "14px" }}>{error}</div>}
      {file?.originalname && (
        <div style={{ fontSize: "14px" }}>
          Uploaded File: {file?.originalname ?? ""}
        </div>
      )}
    </>
  );
};

export default RegisterImageUpload;
